<ngx-smart-modal #noStudioModal identifier="noStudioModal">
  <div class="d-flex justify-content-center">
    <h2>{{ 'UPGRADE_TO_STUDIO' | translate }}</h2>
  </div>
</ngx-smart-modal>
